
<template>
  <div id="app" ref="app" class="APP">
    <!-- 鼠标跟随图片 -->
    <div 
      class="cursor-follower" 
      :style="{ 
        left: (cursorX - 1.5) + 'px', 
        top: (cursorY - 4) + 'px',
        display: cursorVisible ? 'block' : 'none'
      }"
    >
      <img :src="cursorImage" alt="鼠标跟随" @error="handleImageError">
    </div>
    
    <router-view></router-view>
    <BackTop />
  </div>
</template>

<script>
import Home from '@/views/Home'
export default {
  name: 'App',
  components: {
    Home,
  },
  data() {
    return {
      cursorX: 100,
      cursorY: 100,
      cursorVisible: false,
      cursorImage: require('@/assets/img/cursor-image.png'),
      imageError: false
    }
  },
  mounted() {
    this.initCursorFollower()
  },
  beforeDestroy() {
    this.removeEventListeners()
  },
  watch: {
    $route() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  },
  methods: {
    initCursorFollower() {
      document.addEventListener('mousemove', this.handleMouseMove)
      document.addEventListener('mouseenter', this.handleMouseEnter)
      document.addEventListener('mouseleave', this.handleMouseLeave)
      this.cursorVisible = false
    },
    handleMouseMove(e) {
      this.cursorX = e.clientX
      this.cursorY = e.clientY
      this.cursorVisible = true
    },
    handleMouseEnter() {
      this.cursorVisible = true
    },
    handleMouseLeave() {
      this.cursorVisible = false
    },
    handleImageError() {
      this.imageError = true
      this.cursorImage = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzAiIGN5PSIzMCIgcj0iMjgiIGZpbGw9IiMxODkwZmYiIGZpbGwtb3BhY2l0eT0iMC4xIi8+CjxjaXJjbGUgY3g9IjMwIiBjeT0iMzAiIHI9IjI1IiBzdHJva2U9IiMxODkwZmYiIHN0cm9rZS13aWR0aD0iMiIvPgo8Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSIxNSIgZmlsbD0iIzE4OTBmZiIvPgo8L3N2Zz4K'
    },
    removeEventListeners() {
      document.removeEventListener('mousemove', this.handleMouseMove)
      document.removeEventListener('mouseenter', this.handleMouseEnter)
      document.removeEventListener('mouseleave', this.handleMouseLeave)
    }
  }
}
</script>

<style lang="scss">
* {
  // .APP{
  //   max-width: 1980px;
  //   margin: 0 auto;
  // }
  box-sizing: border-box;
}

/* 鼠标跟随样式 - 移除隐藏默认光标的代码 */
.cursor-follower {
  position: fixed;
  width: 60px;
  height: 60px;
  pointer-events: none;
  z-index: 9999;
  transition: transform 0.15s ease-out;
  transform: translate3d(0, 0, 0); /* 启用硬件加速 */
}

.cursor-follower img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  // border: 2px solid #1890ff;
  // box-shadow: 0 0 15px rgba(24, 144, 255, 0.6);
  transition: all 0.3s ease;
}

/* 悬停效果 */
.cursor-follower:hover img {
  transform: scale(1.1);
  border-color: #52c41a;
  box-shadow: 0 0 20px rgba(82, 196, 26, 0.8);
}

/* 移动端禁用 */
@media (max-width: 768px) {
  .cursor-follower {
    display: none !important;
  }
}

.carousel_wrap {
  position: relative;
  .carousel_banner{
    height: calc(100vh);
    padding-top: 70px;
    .circle-arrow {
        position:absolute;
        display: inline-block;
        bottom: 40px;
        left: 49%;
        width: 40px;
        height: 40px;
        border: 2px solid white;
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.3s ease;
      }
      
      .circle-arrow::after {
          content: '';
          position: absolute;
          top: 40%;
          left: 50%;
          width: 12px;
          height: 12px;
          border-right: 2px solid white;
          border-bottom: 2px solid white;
          transform: translate(-50%, -40%) rotate(45deg);
          transition: all 0.3s ease;
      }
  }
  
  .img_item1{
    // margin-top: 70px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .el-carousel__container{
    height: 100%;
    .el-carousel__item {
      img {
        // margin-top: 70px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  
  .tips_font {
    position: absolute;
    top: 260px;
    left: 300px;
    z-index: 5;
    color: #fff;
    font-size: 25px;
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}
@import url('./assets/css/icon.css');
</style>